import React, { useState } from "react";
import Layout from "../../components/layout";
import { Col, Form, Row, Select, Button, message, Card } from "antd";
import axios from "axios";
const { Option } = Select;

// Standard days (Monday - Sunday)
const standardDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
  "By Appointment",
  "4th or 5th Saturday of the Month",
  "2nd or 3rd Tuesday of the Month",
];

// Weekday
const weekdays = ["Monday to Friday"];

// Categories (determines prefix)
const dayCategories = ["Standard", "Alternate", "Last", "Everyday", "Weekday"];

const CreateClinicDay = () => {
  const [selectedCategory, setSelectedCategory] = useState("Standard");
  const [selectedDay, setSelectedDay] = useState("");

  // Dynamically generate days based on category
  const getDaysByCategory = () => {
    if (selectedCategory === "Standard") return standardDays;
    if (selectedCategory === "Everyday") return ["Everyday"];
    if (selectedCategory === "Weekday") return weekdays;
    return standardDays.map((day) => `${selectedCategory} ${day}`);
  };

  const createClinicDay = async () => {
    if (!selectedDay) {
      message.error("Please select a clinic day.");
      return;
    }

    try {
      await axios.post("/api/user/create-clinic-day", { name: selectedDay });
      message.success(`Clinic day "${selectedDay}" created successfully!`);
      setSelectedDay("");
    } catch (error) {
      message.error(error.response?.data?.message || "Error creating clinic day.");
    }
  };

  return (
    <Layout>
      <Card title="Create Clinic Day" style={{ maxWidth: 800, margin: "0 auto" }}>
        <Form layout="vertical" className="formFactor">
          <Row gutter={20}>
            <Col span={12} xs={24} sm={12} lg={12}>
              {/* Select Category: Standard, Alternate, Last */}
              <Form.Item label="Day Category">
                <Select
                  placeholder="Select a category"
                  value={selectedCategory}
                  onChange={(value) => {
                    setSelectedCategory(value);
                    setSelectedDay(""); // Reset selected day
                  }}
                  style={{ width: "100%" }}
                >
                  {dayCategories.map((category) => (
                    <Option key={category} value={category}>
                      {category}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12} xs={24} sm={12} lg={12}>
              {/* Select Specific Day (Dynamically Filtered) */}
              <Form.Item label="Select Clinic Day">
                <Select
                  placeholder="Select a clinic day"
                  value={selectedDay}
                  onChange={setSelectedDay}
                  style={{ width: "100%" }}
                  disabled={selectedCategory === ""}
                >
                  {getDaysByCategory().map((day) => (
                    <Option key={day} value={day}>
                      {day}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <div>
            <Form.Item>
              <Button type="primary"    className="btn-primary" onClick={createClinicDay} htmlType="submit">
                CREATE
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Card>
    </Layout>
  );
};

export default CreateClinicDay;
